import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Order from "./Order";
import { useAuth } from "../../context/GlobalState";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const {user} = useAuth();

  useEffect(()=> {

    if(user) {

      const collRef= collection(db, "users", user?.uid , "orders");

      const orderedRef = query(collRef , orderBy("created" , "desc"));

      onSnapshot(orderedRef , (querySnapshot)=> {

        setOrders(querySnapshot.docs.map((doc)=> (
          {
            id:doc.id,
            data:doc.data(),
          }
        )));
      })

    }else {
      setOrders([]);
    }
  } , [user]);

  return (
    <Box>
      <Typography variant="h5" fontWeight={600}
      sx={{my:{xs:2 , sm:4 , md:6} , mx:{xs:1 , sm:4 , md:6}}}
      >Your Orders</Typography>
      <Box>
        {orders?.map((order) => (
          <Order order={order} />
        ))}
      </Box>
    </Box>
  );
}
